import canUseDOM from './canUseDOM';

const gtmPush = event => {
  if (!canUseDOM) return;
  window.dataLayer.push(event);
};

export default gtmPush;
